module.exports = __webpack_public_path__ + "img/PL08493.5794458b.png";